import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from './plugins/vuetify';
import AsyncComputed from "vue-async-computed";
import '@mdi/font/css/materialdesignicons.css';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

Vue.config.productionTip = false;

Vue.use(require("vue-cookies"));
Vue.use(AsyncComputed);

import DateRangePicker from "./components/DateRangePicker.vue";
import DateRangePickerFallback from "./components/DateRangePickerFallback.vue";
try {
  //throw new Error("Internet Explorer breaks everything and I hate it")
  const VCalendar = require("v-calendar").default;
  Vue.use(VCalendar, { componentPrefix: 'vc' });
  Vue.component('DateRangePicker', DateRangePicker);
} catch (ex) {
  Vue.component('DateRangePicker', DateRangePickerFallback);
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount("#app");
